<template>
  <div>
    <div v-if="showfakeStats" class="is-border" style="margin-top: 50px">
      <fake-stats></fake-stats>
    </div>
    <div class="has-bg-white is-border is-radius-large is-margin-top" v-else-if="salesEntities && salesEntities.length">
      <div class="is-padding is-margin-top">
        <div class="title is-4">Evolution ventes de la société</div>
      </div>
      <div class="is-padding">
        <stats-charts v-if="salesEntities"
                      :entities="salesEntities"
                      :entity-key="'sales'"
                      :date-param="'reservation_date'"
                      :chart-name="'Nombre de ventes'"></stats-charts>
      </div>
    </div>
  </div>
</template>

<script>
  import FakeStats from './FakeStats'
  export default {
    name: 'CompanyChartPane',
    components: { FakeStats },
    props: {
      salesEntities: {
        type: Array,
        default: []
      }
    },
    computed: {
      showfakeStats () {
        return JSON.parse(this.$configs.FAKE_STATS) === 1
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/company/CompanyVuePanels/CompanyChartsPane.vue